import { h } from 'vue';

export function VText(props, { slots, attrs }) {
  const el = props.el || 'span';
  const fontClass = `font-${props.size}`;
  const colorClass = `text-${props.color}`;
  return h(el, { class: [fontClass, colorClass, attrs.class] }, [slots?.default()]);
}
Text.props = ['size', 'color', 'el'];
